
export const SavedMarketStateFilterGraphQLQueryKeys = {
	all: ['market-state'] as const,
	list: (companyHotelId: number) => [...SavedMarketStateFilterGraphQLQueryKeys.all, 'list', companyHotelId],
	default: (companyHotelId: number) => [...SavedMarketStateFilterGraphQLQueryKeys.list(companyHotelId), 'default']
}